















import { Component, Vue, Prop } from "vue-property-decorator";
@Component({})
export default class ProjectDetailHeader extends Vue {
  @Prop()
  private project: any;
  @Prop()
  private noset: any;
  /**
   * @description 返回项目列表
   */
  private goToList() {
    this.$router.push("/main/project/project-list");
  }
  /**
   * @description 打开设置
   */
  private openSet() {
    this.$emit("open");
  }
}
